define('configuration/formkit.form.object.content.configuration',['require','exports','module','backbone','formkit/formkit','view/form/person.finder.content.view','view/form/primary.contact.finder.content.view','view/form/rich.text.content.view','view/form/unit.finder.content.view','view/form/external.org.finder.content.view','view/form/attachment.point.content.view','view/form/significant.financial.interest.content.view'],function(require, exports, module) {
  //prettier-ignore
  var Backbone                                 = require('backbone'),
      FormKit                                  = require('formkit/formkit'),
      PersonFinderContentView                  = require('view/form/person.finder.content.view'),
      PrimaryContactFinderContentView          = require('view/form/primary.contact.finder.content.view'),
      RichTextContentView                      = require('view/form/rich.text.content.view'),
      UnitFinderContentView                    = require('view/form/unit.finder.content.view'),
      ExternalOrgFinderContentView             = require('view/form/external.org.finder.content.view'),
      AttachmentPointContentView               = require('view/form/attachment.point.content.view'),
      SignificantFinancialInterestContentView  = require('view/form/significant.financial.interest.content.view');

  var significantFinancialInterestOptions = {
    childTemplateObject: { typeName: 'Text Input' },
    initializeNewTemplateObject: function(form, templateObjectModel) {
      // Insert mandatory organization finder into this relationship
      var selectOrganizationQuestionObject = form.insertTemplateObject(templateObjectModel, {
        text: 'Select Organization',
        typeName: 'External Org Finder',
      });

      // Specify the mandatory nature of the initialized finder object. Use custom property in order to persist.
      var customAttribute = selectOrganizationQuestionObject.get('custom');
      if (customAttribute instanceof Backbone.Model) {
        customAttribute.set({ mandatory: true });
      } else {
        customAttribute = new Backbone.Model();
        customAttribute.set({ mandatory: true });
        selectOrganizationQuestionObject.set({ custom: customAttribute });
      }

      // This finder object shall always be required
      selectOrganizationQuestionObject.set({ required: true });

      // Make mandatory organization finder truly required (depends on required attribute already being set)
      form.util.insertRequiredRule(selectOrganizationQuestionObject);

      // Insert standard first question for user (template administrator) configuration
      form.insertTemplateObject(templateObjectModel, significantFinancialInterestOptions.childTemplateObject);
    },
  };
  var FormKitFormObjectContentConfiguration = {
    radioEvents: {
      'app configure': 'onAppConfigure',
    },

    onAppConfigure: function() {
      FormKit.Form.registerContentView('Person Finder', PersonFinderContentView)
        .registerContentView('Primary Contact Finder', PrimaryContactFinderContentView)
        .registerContentView('Rich Text Input', RichTextContentView)
        .registerContentView('Unit Finder', UnitFinderContentView)
        .registerContentView('External Org Finder', ExternalOrgFinderContentView)
        .registerContentView('Attachment Point', AttachmentPointContentView)
        .registerContentView(
          'Significant Financial Interest',
          SignificantFinancialInterestContentView,
          significantFinancialInterestOptions
        );
    },
  };

  module.exports = FormKitFormObjectContentConfiguration;
});

